import React, { FC } from 'react'
import { ArticleHeadlineProps } from '@sport1/types/web'
import Font from '@sport1/news-styleguide/Font'
import { sport1Bold } from '@/helpers/fonts'

type props = {
    content: ArticleHeadlineProps
}
const ArticleHeadline: FC<props> = ({ content }) => {
    return (
        <Font
            webHeadlineType="h2"
            fontVariant={['Headline-M', 'Headline-M', 'Display-L']}
            fontFamilyVariant="Sport1-Bold-Headline"
            nextFontFamilyVariant={sport1Bold.style.fontFamily}
            marginBottom="spacing-9"
            testID="article-headline"
        >
            {content.text}
        </Font>
    )
}

export default ArticleHeadline
